// extracted by mini-css-extract-plugin
export default {"EditContent":"styles_EditContent__KBvgo","row":"styles_row__xkshC","col":"styles_col__SFWWL","mediaContainer":"styles_mediaContainer__x+kvv","media":"styles_media__233Ih"};